import { useState } from "react";
import uiuxImg from "../../common/images/p-2.png";
import crmImg from "../../common/images/p-3.png";
import webdevImg from "../../common/images/p-1.png";
import appdevImg from "../../common/images/p-4.png";
import automationImg from "../../common/images/p-5.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const services = [
  {
    id: 5,
    img: automationImg,
    title: "Custom Software Development",
    description:
      "Delivering bespoke software solutions built for efficiency and growth.",
    mark: "customSoftwareDevelopment",
    position: "left-[0px] bottom-[0px]",

    link: "/custom-software-development",
  },
  {
    id: 4,
    img: appdevImg,
    title: "Android Development",
    description:
      "Building seamless, user-friendly mobile apps that enhance digital experiences…",
    mark: "appdev",
    position: "left-[100px] bottom-[200px]",
    link: "/android-development",
  },
  {
    id: 1,
    img: crmImg,
    title: "CRM Development",
    description:
      "CRM development enhances performance and user experience with robust quality checks and seamless integrations.",
    mark: "crm",
    position: "right-[0px] bottom-[200px]",
    link: "/crm-development",
  },
  {
    id: 2,
    img: uiuxImg,
    title: "UI/UX Design",
    description:
      "Creating intuitive and visually stunning designs that captivate users…",
    mark: "uiux",
    position: "left-[100%] bottom-[0px]",
    link: "/uiux-designer",
  },
  {
    id: 3,
    img: webdevImg,
    title: "Web Development",
    description:
      "Crafting high-performance, scalable websites tailored to your business needs…",
    mark: "webdev",
    position: "left-[50%] -top-[50px]",
    link: "/website-development",
  },
];

export default function Services({ selected, setSelected }) {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.2 });

  return (
    <div>
      <div className="max-w-[1000px] mx-auto py-12 px-4 text-center">
        <div ref={ref} className="text-center max-w-4xl mx-auto">
          <motion.h3
            className="text-webOranage small:text-3xl text-xl font-semibold text-center"
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            Our Work Our Excellence.
          </motion.h3>

          <motion.h2
            className="md:text-4xl text-2xl font-bold mt-2 text-secondary"
            initial={{ opacity: 0, y: -50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Showcasing Innovation & Impact
          </motion.h2>

          <motion.p
            className="mx-auto text-[15px] text-center mt-2 text-gray-700 font-bold"
            initial={{ opacity: 0, y: -50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.4 }}
          >
            Explore our portfolio of cutting-edge web, mobile, and custom
            software solutions. From UI/UX design to seamless functionality, our
            work speaks for itself.
          </motion.p>
        </div>

        {/* Line Design */}
        <div className="relative w-full max-w-[800px] mx-auto mt-10">
          {/* Dotted Line */}
          <div className="absolute top-1/2 left-0 w-full h-[4px] border-t-2 border-dashed border-primary"></div>

          {/* Icons Positioned on the Line */}
          <div className="relative flex justify-between items-center w-full">
            {services.map((service) => (
              <div
                key={service.id}
                className={`flex items-center justify-center rounded-full shadow-lg cursor-pointer transition-all duration-300
                ${
                  selected === service.id
                    ? "scale-125 bg-secondary text-white sm:size-[100px] size-[60px]"
                    : "bg-[#AFDCFF] size-12 sm:size-20"
                } hover:scale-110`}
                onClick={() => setSelected(service.id)}
              >
                <Link
                  to={service.link}
                  className="size-[70%] grid overflow-hidden"
                >
                  <div className="w-full  place-items-center">
                    <img
                      src={service.img}
                      alt={service.title}
                      className="sm:h-14 h-8 cursor-pointer object-fill"
                    />
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>

        {/* Selected Service Details */}
        {/* <div className="mt-10 bg-[#AFDCFF] p-6 rounded-lg shadow-md text-center max-w-lg mx-auto">
          <h3 className="text-xl font-bold text-blue-900">
            {services.find((s) => s.id === selected)?.title}
          </h3>
          <p className="text-gray-600 mt-2">
            {services.find((s) => s.id === selected)?.detail}
          </p>
        </div> */}
      </div>
    </div>
  );
}
